(function () {
  angular
    .module('kareo.ui.shared.directives.services.enrollments-service', ['kareo.ui.shared.modules.data'])
    .factory('enrollmentsService', enrollmentsService);

  enrollmentsService.$inject = ['$http', '$q', 'practice'];

  function enrollmentsService($http, $q, practice) {
    const BASE_URL = '/enrollments-ui/api/';
    const svc = {
      addPayers,
      getCommonPayers,
      getHasAssistedEnrollments,
      getSalesforceCaseHistory,
      getPayerDetails,
      getPayerDetailsPagination,
      getPracticePayerListSearch,
      getPayerDetailsByPayerIds,
      getPracticeInfo,
      submitSalesForceInfo,
      getCustomerClearinghouses,
      getInsuranceCompany,
      getInsuranceCompanyPlans,
      getInsurancePrograms,
      updateInsuranceCompany,
      createInsuranceCompanies,
      deleteInsuranceCompany,
      addInsurancePlan,
      updateInsurancePlan,
      deleteInsurancePlan,
      setupInfoExists,
      getProvidersPerPractice,
      getInsuranceOverrideClaimSettings,
      getSetupInfo,
      getClaimProviderInfo,
      getDraftEnrollment,
      deleteDraftEnrollment,
      getDraftEnrollmentId,
      saveDraftEnrollment,
      submitEnrollmentSetupInfo,
      getDraftEnrollments,
      getDraftEnrollmentsCount
    };

    return svc;

    //----------------------

    function addPayers(item) {
      const REQUEST_URL = BASE_URL + 'InsuranceCompany/' +
        'CreatePayerConnection';

      return $http
        .post(REQUEST_URL, item)
        .then((response) => response.data.payerDetails, () => $q.reject());
    }

    function addInsurancePlan(insuranceCompanyPlan) {
      const REQUEST_URL = '/enrollments-ui/api/InsuranceCompany/' +
        'CreateInsuranceCompanyPlan';

      return $http
        .post(REQUEST_URL, insuranceCompanyPlan)
        .then((response) => response.data, () => $q.reject());
    }

    function updateInsurancePlan(insuranceCompanyPlan) {
      const REQUEST_URL = '/enrollments-ui/api/InsuranceCompany/' +
        'UpdateInsuranceCompanyPlan';

      return $http
        .put(REQUEST_URL, insuranceCompanyPlan)
        .then((response) => response.data, () => $q.reject());
    }

    function deleteInsurancePlan(insuranceCompanyPlanId) {
      const REQUEST_URL = '/enrollments-ui/api/InsuranceCompany/DeleteInsuranceCompanyPlan/' + insuranceCompanyPlanId;

      return $http
        .delete(REQUEST_URL)
        .then((response) => response.data, (deleteError) => $q.reject(deleteError));
    }

    function getCommonPayers() {
      const REQUEST_URL = BASE_URL + 'InsuranceCompany/' +
        'CommonPayers';

      return $http
        .get(REQUEST_URL)
        .then((response) => response.data.payerDetails, () => $q.reject());
    }

    function getPayerDetails(shouldIncludeCustom, providerId, providerNPI) {
      const REQUEST_URL = BASE_URL + 'InsuranceCompany/GetPracticePayerList';

      return $http({
        method: 'GET',
        url: REQUEST_URL,
        params: {
          hasCustomInsuranceCompanies: !!shouldIncludeCustom,
          isGroup: !providerId,
          pmProviderId: providerId || 0,
          providerNPI
        }
      })
      .then((response) => response.data, () => $q.reject());
    }

    function getPayerDetailsPagination(shouldIncludeCustom, providerId, providerNPI, pageSize, pageIndex, statusInsurance, statusFilter, statusColumn, scope, insuranceCompanyId, queryFilter) {
      const REQUEST_URL = BASE_URL + 'InsuranceCompany/GetPracticePayerListPagination';
      return $http({
        method: 'GET',
        url: REQUEST_URL,
        params: {
          pageSize: pageSize,
          pageIndex: pageIndex,
          status: statusInsurance,
          statusFilter: statusFilter,
          statusColumn: statusColumn,
          scope: scope,
          query: queryFilter,
          insuranceCompanyId: insuranceCompanyId,
          hasCustomInsuranceCompanies: !!shouldIncludeCustom,
          isGroup: !providerId,
          pmProviderId: providerId || 0,
          providerNPI
        }
      })
        .then((response) => response.data, () => $q.reject());
    }

    function getPracticePayerListSearch(shouldIncludeCustom, providerId, providerNPI, pageSize, pageIndex, statusInsurance, statusFilter, statusColumn, scope) {
      const REQUEST_URL = BASE_URL + 'InsuranceCompany/GetPracticePayerListSearch';
      return $http({
        method: 'GET',
        url: REQUEST_URL,
        params: {
          pageSize: pageSize,
          pageIndex: pageIndex,
          status: statusInsurance,
          statusFilter: statusFilter,
          statusColumn: statusColumn,
          scope: scope,
          hasCustomInsuranceCompanies: !!shouldIncludeCustom,
          isGroup: !providerId,
          pmProviderId: providerId || 0,
          providerNPI
        }
      })
        .then((response) => response.data, () => $q.reject());
    }


    function getPayerDetailsByPayerIds(providerId, providerNPI, clearingHousePayerIds) {
      const REQUEST_URL = BASE_URL + 'InsuranceCompany/GetPracticePayerListByIds';
      const data = {
        pmProviderId: providerId,
        group: !providerId,
        providerNPI,
        clearingHousePayerIds
      };

      return $http
        .post(REQUEST_URL, data)
        .then((response) => response.data, () => $q.reject());
    }

    function getHasAssistedEnrollments() {
      const REQUEST_URL = BASE_URL + 'Salesforce/Customer/' +
        'AssistedEnrollments';

      return $http
        .get(REQUEST_URL)
        .then((response) => response.data, () => $q.reject());
    }


      function getSalesforceCaseHistory(salesforceCaseId, payerNumber, enrollmentCode) {
          const REQUEST_URL = BASE_URL + 'Salesforce/CaseStatusHistory/' + salesforceCaseId + '/' + payerNumber + '/' + enrollmentCode;

          return $http
              .get(REQUEST_URL)
              .then((response) => response.data, () => $q.reject());
      }

    function getPracticeInfo() {
      const REQUEST_URL = BASE_URL + 'PracticeInfo';

      return $http
        .get(REQUEST_URL, { cache: true })
        .then((response) => response.data, () => $q.reject());
    }

    function submitSalesForceInfo(setupInfo, providerId) {
      const REQUEST_URL = BASE_URL + 'Salesforce/SubmitSetupInfo';
      const params = {
        isGroup: !providerId
      };
      return $http
        .post(REQUEST_URL, setupInfo, { params })
        .then((response) => response.data, () => $q.reject());
    }

    function getCustomerClearinghouses() {
      const REQUEST_URL = BASE_URL + 'InsuranceCompany/clearinghousePayers';

      return $http
       .get(REQUEST_URL)
       .then((response) => response.data, () => $q.reject());
    }

    function createInsuranceCompanies(payersList) {
          const REQUEST_URL = BASE_URL + 'InsuranceCompany/CreateInsuranceCompanies';

          return $http
              .post(REQUEST_URL, payersList)
              .then((response) => response.data, () => $q.reject());
      }

    function deleteInsuranceCompany(insuranceCompanyId) {
          const REQUEST_URL = BASE_URL + 'InsuranceCompany/' + insuranceCompanyId;

        return $http
            .delete(REQUEST_URL)
            .then((response) => response.data, (deleteError) => $q.reject(deleteError));
      }

    function getInsuranceCompany(id) {
      const REQUEST_URL = BASE_URL + 'InsuranceCompany/' + id;

      return $http
        .get(REQUEST_URL)
        .then((response) => response.data, () => $q.reject());
    }

    function getInsuranceCompanyPlans(id) {
      const REQUEST_URL = BASE_URL + 'InsuranceCompany/GetInsuranceCompanyPlansList?insuranceCompanyId=' + id;

      return $http
        .get(REQUEST_URL)
        .then((response) => response.data, () => $q.reject());
    }

    function getInsurancePrograms() {
      const REQUEST_URL = BASE_URL + 'InsuranceCompany/InsuranceProgram';

      return $http
        .get(REQUEST_URL)
        .then((response) => response.data, () => $q.reject());
    }

    function updateInsuranceCompany(data) {
      const REQUEST_URL = BASE_URL + 'InsuranceCompany/';

      return $http
        .put(REQUEST_URL, data)
        .then((response) => response.data, () => $q.reject());
    }

    function setupInfoExists(providerId) {
      const isGroup = !providerId;
      const REQUEST_URL = BASE_URL + 'InsuranceCompany/provider/' +
                            (providerId || 0) +
                            '/group/' + isGroup + '/setupInfoExists';
      return $http.get(REQUEST_URL);
    }

    function getProvidersPerPractice() {
      // Added a temporary fix, Once PM issue(EHR-27699) is fixed, CustomerId and practiceGuid should not be passed
      return practice.get().then((response) => {
        const url = '/enrollments-ui/api/ProviderInfo/' + response.customerId + '/GetProvidersPerPractice/' + response.practiceGuid;
        return $http.get(url)
                    .then((res) => res.data);
      });
    }

    function getInsuranceOverrideClaimSettings() {
      const url = '/enrollments-ui/api/ProviderInfo/InsuranceOverrideClaimSettings';
      return $http.get(url)
        .then((res) => res.data);
    }

    function getSetupInfo(providerId) {
      const url = '/enrollments-ui/api/Salesforce/getSetupInfo';
      const params = {
        pmProviderId: providerId || 0,
        isGroup: !providerId
      };
      return $http.get(url, { params })
                  .then((response) => response.data);
    }

    function getClaimProviderInfo(pmProviderId) {
      const url = BASE_URL + 'ProviderInfo/ClaimSettings/Provider/' + pmProviderId;
      return $http.get(url)
                  .then((response) => response.data);
    }

    function getDraftEnrollment(setupInfoId) {
      const url = BASE_URL + 'Enrollment/DraftSetupInfo/' + setupInfoId;
      const deferred = $q.defer();

      $http.get(url)
      .then((response) => {
        deferred.resolve(response.data);
      }, (err) => {
        deferred.reject(err);
        return deferred.promise;
      });
      return deferred.promise;
    }

    function deleteDraftEnrollment(setupInfoId) {
      const url = BASE_URL + 'Enrollment/DraftSetupInfo/' + setupInfoId;
      const deferred = $q.defer();

      $http.delete(url)
      .then((response) => {
        deferred.resolve(response.data);
      }, (err) => {
        deferred.reject(err);
        return deferred.promise;
      });
      return deferred.promise;
    }

    function getDraftEnrollmentId(providerGuid) {
      const url = BASE_URL + 'Enrollment/draftId';
      const params = {};
      if (providerGuid) {
        params.providerGuid = providerGuid;
      }

      const deferred = $q.defer();

      $http.get(url, { params })
      .then((response) => {
        deferred.resolve(response.data);
      }, (err) => {
        deferred.reject(err);
        return deferred.promise;
      });
      return deferred.promise;
    }

    function getDraftEnrollments() {
      const url = BASE_URL + 'Enrollment/draftEnrollments';
      const deferred = $q.defer();

      $http.get(url)
      .then((response) => {
        deferred.resolve(response.data);
      }, (err) => {
        deferred.reject(err);
        return deferred.promise;
      });
      return deferred.promise;
    }

    function getDraftEnrollmentsCount() {
      const url = BASE_URL + 'Enrollment/draftCount';
      const deferred = $q.defer();

      $http.get(url)
      .then((response) => {
        deferred.resolve(response.data);
      }, (err) => {
        deferred.reject(err);
        return deferred.promise;
      });
      return deferred.promise;
    }

    function saveDraftEnrollment(draftEnrollmentSetupInfo) {
      const url = BASE_URL + 'Enrollment/DraftSetupInfo';
      const deferred = $q.defer();

      $http.post(url, draftEnrollmentSetupInfo)
      .then((response) => {
        deferred.resolve(response.data);
      }, (err) => {
        deferred.reject(err);
        return deferred.promise;
      });
      return deferred.promise;
    }

    function submitEnrollmentSetupInfo(draftEnrollmentSetupInfo) {
      const url = BASE_URL + 'Enrollment/submit';
      const deferred = $q.defer();

      $http.post(url, draftEnrollmentSetupInfo)
      .then((response) => {
        deferred.resolve(response.data);
      }, (err) => {
        deferred.reject(err);
        return deferred.promise;
      });
      return deferred.promise;
    }
  }
})();
